// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"928b3e53","167":"5f839d94","201":"836598f4","267":"518a0c08","302":"5837389b","488":"e8efcaf8","545":"0ee8d99f","648":"62338d12","837":"cba262bf","888":"9fd24d82","896":"6d9bb648","901":"cd18dd18","912":"115ebdf9","998":"21655753"}[chunkId] + ".chunk.js";
};